import type { PatternDesignFeature } from '~api/services';
import type { OptimisationDrillHoleProperties } from '~types';
import { DRILL_HOLE_DEFAULTS } from '../config';

/**
 * Extract drill hole data from pattern design feature
 * @param {PatternDesignFeature} feature - The pattern design feature
 * @param {number} index - Index of the feature in the collection
 * @returns {OptimisationDrillHoleProperties | null} Drill hole data or null if extraction fails
 */
export const extractDrillHole = (
  feature: PatternDesignFeature,
  index: number,
): OptimisationDrillHoleProperties | null => {
  if (feature.geometry?.type !== 'Point') return null;

  const props = feature.properties;
  const coords = feature.geometry.coordinates;

  if (!coords || coords.length < 2 || !Number.isFinite(coords[0]) || !Number.isFinite(coords[1])) return null;

  return {
    hole_name: props?.hole_name || `hole-${index}`,
    lon: coords[0],
    lat: coords[1],
    diameter: props?.diameter ?? DRILL_HOLE_DEFAULTS.DIAMETER,
    depth: props?.depth ?? DRILL_HOLE_DEFAULTS.DEPTH,
    burden: props?.burden ?? DRILL_HOLE_DEFAULTS.BURDEN,
    spacing: props?.spacing ?? DRILL_HOLE_DEFAULTS.SPACING,
    bearing: props?.bearing ?? DRILL_HOLE_DEFAULTS.BEARING,
    dip: props?.dip ?? DRILL_HOLE_DEFAULTS.DIP,
    blast_mj: props?.blast_mj ?? DRILL_HOLE_DEFAULTS.BLAST_MJ,
    crush_mj: props?.crush_mj ?? DRILL_HOLE_DEFAULTS.CRUSH_MJ,
    dig_mj: props?.dig_mj,
    drill_mj: props?.drill_mj,
    charge_design: props?.charge_design,
  };
};
